import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GameProvider } from "@/context/GameContext";
import LandingPage from "@/pages/LandingPage";
import PlayRoom from "@/pages/PlayRoom";
import ParentDashboard from "@/pages/ParentDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ControlSystem from "@/pages/ControlSystem";
import AdvertiserPortal from "@/pages/AdvertiserPortal";
import HealthAdventure from "@/pages/HealthAdventure";
import TermsConditions from "@/pages/TermsConditions";
import OfflineBanner from "@/components/OfflineBanner";
import { Toaster } from "sonner";

export const ENABLE_HEALTH_ADVENTURE = true;

function App() {
  return (
    <div className="App">
      <GameProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/play/:age" element={<PlayRoom />} />
            {ENABLE_HEALTH_ADVENTURE && (
              <Route path="/play/health" element={<HealthAdventure />} />
            )}
            <Route path="/parent" element={<ParentDashboard />} />
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/controlsystem" element={<ControlSystem />} />
            <Route path="/partner" element={<AdvertiserPortal />} />
            <Route path="/advertiser" element={<AdvertiserPortal />} />
            <Route path="/terms" element={<TermsConditions />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/privacy" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<TermsConditions />} />
            <Route path="/refund" element={<TermsConditions />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <OfflineBanner />
      </GameProvider>
    </div>
  );
}

export default App;
